import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/group-setup/traders.md?raw';

const GroupSetupTraders: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default GroupSetupTraders;
